export function getIframePreviewFlags() {
  const isIframe = typeof window !== 'undefined' && window.self !== window.top;
  let isIframePreview: boolean;

  try {
    // The `is_frame_preview` global is set in express if a `?isFramePreview=true` query parameter
    // is set in the URL. This check to ensure that the iframe is on the same origin is an extra measure
    // to verify that the iframe is running in the correct context.
    const isTopWindowSameOrigin = window.location.origin === window.top?.location.origin;
    isIframePreview = isIframe && isTopWindowSameOrigin && window.is_frame_preview;
  } catch {
    isIframePreview = false;
  }

  return {
    isIframe,
    isIframePreview,
  };
}
